import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import UserNotRegisteredError from '@/components/UserNotRegisteredError';

const Fallback = () => (
  <div className="fixed inset-0 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
  </div>
);

export default function AdminRoute() {
  const { isAuthenticated, isLoadingAuth, authChecked, authError, checkUserAuth, user } = useAuth();

  useEffect(() => {
    if (!authChecked && !isLoadingAuth) {
      checkUserAuth();
    }
  }, [authChecked, isLoadingAuth, checkUserAuth]);

  if (isLoadingAuth || !authChecked) {
    return <Fallback />;
  }

  if (authError) {
    if (authError.type === 'user_not_registered') {
      return <UserNotRegisteredError />;
    }
    return <Navigate to="/login" replace state={{ from: '/admin' }} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: '/admin' }} />;
  }

  if (user?.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16">
        <div className="text-center max-w-md">
          <h1 className="font-display font-extrabold text-navy mb-4" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.25rem)' }}>
            Access Denied
          </h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            You don't have permission to access the admin dashboard. Please contact an administrator if you believe this is an error.
          </p>
          <a href="/" className="inline-block px-6 py-3 bg-navy text-white font-semibold rounded-full hover:bg-navy-light transition-colors">
            Back to Home
          </a>
        </div>
      </div>
    );
  }

  return <Outlet />;
}